import { createContext } from 'react'
import type { AuthState, LoginCredentials, SignUpCredentials } from '@/types'

export type AuthContextValue = AuthState & {
  signUp: (credentials: SignUpCredentials) => Promise<{ data?: unknown; error?: string }>
  signIn: (credentials: LoginCredentials) => Promise<{ data?: unknown; error?: string }>
  signOut: () => Promise<{ success?: boolean; error?: string }>
  resetPassword: (email: string) => Promise<{ success?: boolean; error?: string }>
  updatePassword: (password: string) => Promise<{ success?: boolean; error?: string }>
  updateUserMetadata: (metadata: Record<string, unknown>) => Promise<{ success?: boolean; error?: string }>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
